module.exports = __webpack_public_path__ + "assets-cabinet/img/message.f8151031.svg";